module.exports = __webpack_public_path__ + "img/San-Marino.e1da8621.png";